import { Modal, Select, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { handleSetAdvertListFilter, handleSetIsShowAdvertPreview } from "../ClientStates";
import ProductDetails from 'apps/RealState/Details/ProductDetails';
import { useParams } from "react-router-dom";

const { Option } = Select;

const Sorting = () => {
  const dispatch = useDispatch();
  const { filter, isShowAdvertPreview } = useSelector((state: RootState) => state.realState);
  const params = useParams();
  const type = params["advertType"];
  const applySorterFilter = (value: string) => {
    const parsedKey = value.split("_");

    if (parsedKey.length === 2) {
      const [property, sortType] = parsedKey;

      if (["asc", "desc"].includes(sortType)) {
        const newFilter = {
          SortProperty: property,
          SortType: sortType,
        };
        const allFilter = { ...filter, ...newFilter };

        dispatch(handleSetAdvertListFilter({ filter: allFilter }));
      }
    }
  };

  const options = [
    { value: "price_asc", label: "Fiyata göre (Önce en düşük)" },
    { value: "price_desc", label: "Fiyata göre (Önce en yüksek)" },
    { value: "insertDate_desc", label: "Tarihe göre (Önce en yeni ilan)" },
    { value: "insertDate_asc", label: "Tarihe göre (Önce en eski ilan)" },
    { value: "CityId_asc", label: "Adrese göre (A-Z)" },
    { value: "CityId_desc", label: "Adrese göre (Z-A)" },
  ];

  if (type === "vasita") {
    options.push(
      { value: "KM_asc", label: "Km göre (Önce en düşük)" },
      { value: "KM_desc", label: "Km göre (Önce en yüksek)" },
      { value: "Yıl_desc", label: "Yıla göre (Önce en yeni)" },
      { value: "Yıl_asc", label: "Yıla göre (Önce en eski)" }
    );
  }


const {Text} = Typography
  return (
    <>
      <Select
     id="advert-list-sorting"
      bordered={false} defaultValue={"price_asc"} className="!w-full  " onChange={applySorterFilter}>
        {options.map((item) => (
          <Option className=" "  key={item.value} value={item.value}><Text className="!text-xs sm:!text-sm" >{item.label}</Text></Option>
        ))}
      </Select>
      <Modal
        open={isShowAdvertPreview}
        footer={false}
        onCancel={() => {
          dispatch(handleSetIsShowAdvertPreview({ status: false }));
        }}
        className="!w-full"
      >
        <ProductDetails />
      </Modal>
  
    </>
  );
};

export default Sorting;
